const data5 = [
  {
    'groupId': 416,
    'batchNos': '201809031848011705',
    'companyName': '评分策略组-A',
    'importTime': '2018-09-03',
    'groupName': '深圳金钱包1-10',
    'averagePlayDays': 2,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442.67,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 1,
    'totalCount': 3,
    'playDays': 6,
    'overdueDates': 12,
    'caseAmount': 4328,
    'msgSendCount': 2,
    'ivrSendCount': 1,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 0,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '0.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 0,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 0,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 183,
    'batchNos': '201809031813055834',
    'companyName': '1南京途牛科技有限公司',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 10,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.67,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 30,
    'overdueDates': 72,
    'caseAmount': 4274,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 253,
    'batchNos': '201809031813044476',
    'companyName': '巨人投资',
    'importTime': '2018-09-03',
    'groupName': '自动化完整策略',
    'averagePlayDays': 5,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.67,
    'averageMsgSendCount': 18,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 15,
    'overdueDates': 72,
    'caseAmount': 4274,
    'msgSendCount': 18,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 240,
    'batchNos': '201809031813044355',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'groupName': '途牛测试组',
    'averagePlayDays': 7,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.67,
    'averageMsgSendCount': 1,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 21,
    'overdueDates': 72,
    'caseAmount': 4274,
    'msgSendCount': 1,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 246,
    'batchNos': '201809031813044783',
    'companyName': '财宝宝信息科技有限公司-上海子公司（杨浦职场）',
    'importTime': '2018-09-03',
    'groupName': '途牛科技-策略组',
    'averagePlayDays': 3,
    'averageOverdueDates': 28,
    'caseTotalCount': 1,
    'averageCaseAmount': 541,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 2,
    'playDays': 6,
    'overdueDates': 56,
    'caseAmount': 1082,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 1,
    'touchCount1': 1,
    'contactCount1': 1,
    'contactReturnCount1': 1,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '100.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '100.00%',
    'contactReturnRate1': '100.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 1,
    'touchCount2': 1,
    'contactCount2': 1,
    'contactReturnCount2': 1,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 1,
    'touchCount3': 1,
    'contactCount3': 1,
    'contactReturnCount3': 1,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 183,
    'batchNos': '201809031813044469',
    'companyName': '1南京途牛科技有限公司',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 10,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.67,
    'averageMsgSendCount': 5,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 30,
    'overdueDates': 72,
    'caseAmount': 4274,
    'msgSendCount': 5,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 217,
    'batchNos': '201809031813044021',
    'companyName': '巨人投资',
    'importTime': '2018-09-03',
    'groupName': '测试策略组1',
    'averagePlayDays': 5,
    'averageOverdueDates': 24,
    'caseTotalCount': 2,
    'averageCaseAmount': 6050,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 2,
    'playDays': 10,
    'overdueDates': 48,
    'caseAmount': 12100,
    'msgSendCount': 4,
    'ivrSendCount': 0,
    'caseCount1': 2,
    'confirmedPaymentCount1': 0,
    'touchCount1': 2,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 2,
    'confirmedPaymentCount2': 0,
    'touchCount2': 2,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 2,
    'confirmedPaymentCount3': 0,
    'touchCount3': 2,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 240,
    'batchNos': '201809031813044836',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'groupName': '途牛测试组',
    'averagePlayDays': 5,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.6,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 1,
    'totalCount': 5,
    'playDays': 25,
    'overdueDates': 120,
    'caseAmount': 7123,
    'msgSendCount': 0,
    'ivrSendCount': 1,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 1,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '100.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 1,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 1,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 240,
    'batchNos': '201809031734021819',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'groupName': '途牛测试组',
    'averagePlayDays': 7,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.67,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 21,
    'overdueDates': 72,
    'caseAmount': 4274,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031726049273',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 7,
    'averageOverdueDates': 2.8,
    'caseTotalCount': 10,
    'averageCaseAmount': 6288.8,
    'averageMsgSendCount': 5.2,
    'averageIvrSendCount': 0,
    'totalCount': 10,
    'playDays': 73,
    'overdueDates': 28,
    'caseAmount': 62888,
    'msgSendCount': 52,
    'ivrSendCount': 0,
    'caseCount1': 10,
    'confirmedPaymentCount1': 1,
    'touchCount1': 10,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 1,
    'totalReturnRate1': '10.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '10.00%',
    'caseCount2': 10,
    'confirmedPaymentCount2': 1,
    'touchCount2': 10,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 1,
    'caseCount3': 10,
    'confirmedPaymentCount3': 1,
    'touchCount3': 10,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 1
  },
  {
    'groupId': 332,
    'batchNos': '201809031656001100',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 9,
    'averageOverdueDates': 10,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 9,
    'overdueDates': 10,
    'caseAmount': 6000,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031654019708',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'averagePlayDays': 1,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 240,
    'batchNos': '201809031652044279',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'groupName': '途牛测试组',
    'averagePlayDays': 1,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442.5,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 2,
    'playDays': 2,
    'overdueDates': 8,
    'caseAmount': 2885,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 409,
    'batchNos': '201809031611055681',
    'companyName': '评分策略组-A',
    'importTime': '2018-09-03',
    'groupName': '评分策略组',
    'averagePlayDays': 2,
    'averageOverdueDates': 1,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 4,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 2,
    'overdueDates': 1,
    'caseAmount': 1442,
    'msgSendCount': 4,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 0,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '0.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 0,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 0,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031607032791',
    'companyName': '凡普金科（接口）',
    'importTime': '2018-09-03',
    'averagePlayDays': 4,
    'averageOverdueDates': 1.5,
    'caseTotalCount': 4,
    'averageCaseAmount': 1934,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 4,
    'playDays': 16,
    'overdueDates': 6,
    'caseAmount': 7736,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 4,
    'confirmedPaymentCount1': 0,
    'touchCount1': 4,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 4,
    'confirmedPaymentCount2': 0,
    'touchCount2': 4,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 4,
    'confirmedPaymentCount3': 0,
    'touchCount3': 4,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031558055798',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031553042812',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031548032311',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031550007021',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031547025307',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031539056382',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031534040466',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031531026160',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031527027290',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031524014426',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031523020656',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 237,
    'batchNos': '201809031510003798',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'groupName': '仿线上',
    'averagePlayDays': 30,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442.67,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 90,
    'overdueDates': 12,
    'caseAmount': 4328,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031509002914',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 11,
    'averageOverdueDates': 1,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 11,
    'overdueDates': 1,
    'caseAmount': 6000,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 1,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '100.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 1,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 1,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031503046920',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031459059478',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 4,
    'averageOverdueDates': 10,
    'caseTotalCount': 3,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 3,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 12,
    'overdueDates': 30,
    'caseAmount': 18000,
    'msgSendCount': 9,
    'ivrSendCount': 0,
    'caseCount1': 3,
    'confirmedPaymentCount1': 0,
    'touchCount1': 3,
    'contactCount1': 2,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '66.67%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 3,
    'confirmedPaymentCount2': 0,
    'touchCount2': 3,
    'contactCount2': 2,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 3,
    'confirmedPaymentCount3': 0,
    'touchCount3': 3,
    'contactCount3': 2,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 246,
    'batchNos': '201809031459039644',
    'companyName': '财宝宝信息科技有限公司-上海子公司（杨浦职场）',
    'importTime': '2018-09-03',
    'groupName': '途牛科技-策略组',
    'averagePlayDays': 3,
    'averageOverdueDates': 28,
    'caseTotalCount': 1,
    'averageCaseAmount': 541,
    'averageMsgSendCount': 1,
    'averageIvrSendCount': 0,
    'totalCount': 2,
    'playDays': 6,
    'overdueDates': 56,
    'caseAmount': 1082,
    'msgSendCount': 1,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 1,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 1,
    'totalReturnRate1': '100.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '100.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 1,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 1,
    'caseCount3': 1,
    'confirmedPaymentCount3': 1,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 1
  },
  {
    'groupId': 332,
    'batchNos': '201809031458053741',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 15,
    'averageOverdueDates': 1,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 5,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 15,
    'overdueDates': 1,
    'caseAmount': 6000,
    'msgSendCount': 5,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 346,
    'batchNos': '201809031453024910',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '评分策略组',
    'averagePlayDays': 1,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442.75,
    'averageMsgSendCount': 5,
    'averageIvrSendCount': 0,
    'totalCount': 4,
    'playDays': 4,
    'overdueDates': 16,
    'caseAmount': 5771,
    'msgSendCount': 5,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031435055936',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 3,
    'averageOverdueDates': 1,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 3,
    'overdueDates': 1,
    'caseAmount': 6000,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 1,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '100.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 1,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 1,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031346023839',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'averagePlayDays': 1,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 11,
    'batchNos': '201809031124045434',
    'companyName': 'chenli建测试公司',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 1,
    'averageOverdueDates': 1,
    'caseTotalCount': 1,
    'averageCaseAmount': 20,
    'averageMsgSendCount': 6,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 1,
    'caseAmount': 20,
    'msgSendCount': 6,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031122037758',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 21,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 6,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 63,
    'overdueDates': 285,
    'caseAmount': 18000,
    'msgSendCount': 6,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031115045304',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031115011357',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031113037268',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031112053201',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031111017584',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031110055725',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'averagePlayDays': 5,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 5,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031110040240',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 7,
    'averageOverdueDates': 5,
    'caseTotalCount': 1,
    'averageCaseAmount': 150,
    'averageMsgSendCount': 8,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 7,
    'overdueDates': 5,
    'caseAmount': 150,
    'msgSendCount': 8,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031110011352',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031109024250',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'averagePlayDays': 3,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 3,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031109000527',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 2,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 8,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 2,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 8,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031107056630',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031106044339',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 5,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 5,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031058003164',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'averagePlayDays': 1,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  }
];
const data3 = [
  {
    'groupId': 416,
    'batchNos': '201809031848011705',
    'companyName': '评分策略组-A',
    'importTime': '2018-09-03',
    'groupName': '深圳金钱包1-10',
    'averagePlayDays': 2,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442.67,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 1,
    'totalCount': 3,
    'playDays': 6,
    'overdueDates': 12,
    'caseAmount': 4328,
    'msgSendCount': 2,
    'ivrSendCount': 1,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 0,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '0.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 0,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 0,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 183,
    'batchNos': '201809031813055834',
    'companyName': '1南京途牛科技有限公司',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 10,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.67,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 30,
    'overdueDates': 72,
    'caseAmount': 4274,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 253,
    'batchNos': '201809031813044476',
    'companyName': '巨人投资',
    'importTime': '2018-09-03',
    'groupName': '自动化完整策略',
    'averagePlayDays': 5,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.67,
    'averageMsgSendCount': 18,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 15,
    'overdueDates': 72,
    'caseAmount': 4274,
    'msgSendCount': 18,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 240,
    'batchNos': '201809031813044355',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'groupName': '途牛测试组',
    'averagePlayDays': 7,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.67,
    'averageMsgSendCount': 1,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 21,
    'overdueDates': 72,
    'caseAmount': 4274,
    'msgSendCount': 1,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 246,
    'batchNos': '201809031813044783',
    'companyName': '财宝宝信息科技有限公司-上海子公司（杨浦职场）',
    'importTime': '2018-09-03',
    'groupName': '途牛科技-策略组',
    'averagePlayDays': 3,
    'averageOverdueDates': 28,
    'caseTotalCount': 1,
    'averageCaseAmount': 541,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 2,
    'playDays': 6,
    'overdueDates': 56,
    'caseAmount': 1082,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 1,
    'touchCount1': 1,
    'contactCount1': 1,
    'contactReturnCount1': 1,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '100.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '100.00%',
    'contactReturnRate1': '100.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 1,
    'touchCount2': 1,
    'contactCount2': 1,
    'contactReturnCount2': 1,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 1,
    'touchCount3': 1,
    'contactCount3': 1,
    'contactReturnCount3': 1,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 183,
    'batchNos': '201809031813044469',
    'companyName': '1南京途牛科技有限公司',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 10,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.67,
    'averageMsgSendCount': 5,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 30,
    'overdueDates': 72,
    'caseAmount': 4274,
    'msgSendCount': 5,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 217,
    'batchNos': '201809031813044021',
    'companyName': '巨人投资',
    'importTime': '2018-09-03',
    'groupName': '测试策略组1',
    'averagePlayDays': 5,
    'averageOverdueDates': 24,
    'caseTotalCount': 2,
    'averageCaseAmount': 6050,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 2,
    'playDays': 10,
    'overdueDates': 48,
    'caseAmount': 12100,
    'msgSendCount': 4,
    'ivrSendCount': 0,
    'caseCount1': 2,
    'confirmedPaymentCount1': 0,
    'touchCount1': 2,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 2,
    'confirmedPaymentCount2': 0,
    'touchCount2': 2,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 2,
    'confirmedPaymentCount3': 0,
    'touchCount3': 2,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 240,
    'batchNos': '201809031813044836',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'groupName': '途牛测试组',
    'averagePlayDays': 5,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.6,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 1,
    'totalCount': 5,
    'playDays': 25,
    'overdueDates': 120,
    'caseAmount': 7123,
    'msgSendCount': 0,
    'ivrSendCount': 1,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 1,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '100.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 1,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 1,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 240,
    'batchNos': '201809031734021819',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'groupName': '途牛测试组',
    'averagePlayDays': 7,
    'averageOverdueDates': 24,
    'caseTotalCount': 1,
    'averageCaseAmount': 1424.67,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 21,
    'overdueDates': 72,
    'caseAmount': 4274,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031726049273',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 7,
    'averageOverdueDates': 2.8,
    'caseTotalCount': 10,
    'averageCaseAmount': 6288.8,
    'averageMsgSendCount': 5.2,
    'averageIvrSendCount': 0,
    'totalCount': 10,
    'playDays': 73,
    'overdueDates': 28,
    'caseAmount': 62888,
    'msgSendCount': 52,
    'ivrSendCount': 0,
    'caseCount1': 10,
    'confirmedPaymentCount1': 1,
    'touchCount1': 10,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 1,
    'totalReturnRate1': '10.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '10.00%',
    'caseCount2': 10,
    'confirmedPaymentCount2': 1,
    'touchCount2': 10,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 1,
    'caseCount3': 10,
    'confirmedPaymentCount3': 1,
    'touchCount3': 10,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 1
  },
  {
    'groupId': 332,
    'batchNos': '201809031656001100',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 9,
    'averageOverdueDates': 10,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 9,
    'overdueDates': 10,
    'caseAmount': 6000,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031654019708',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'averagePlayDays': 1,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 240,
    'batchNos': '201809031652044279',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'groupName': '途牛测试组',
    'averagePlayDays': 1,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442.5,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 2,
    'playDays': 2,
    'overdueDates': 8,
    'caseAmount': 2885,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 409,
    'batchNos': '201809031611055681',
    'companyName': '评分策略组-A',
    'importTime': '2018-09-03',
    'groupName': '评分策略组',
    'averagePlayDays': 2,
    'averageOverdueDates': 1,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 4,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 2,
    'overdueDates': 1,
    'caseAmount': 1442,
    'msgSendCount': 4,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 0,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '0.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 0,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 0,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031607032791',
    'companyName': '凡普金科（接口）',
    'importTime': '2018-09-03',
    'averagePlayDays': 4,
    'averageOverdueDates': 1.5,
    'caseTotalCount': 4,
    'averageCaseAmount': 1934,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 4,
    'playDays': 16,
    'overdueDates': 6,
    'caseAmount': 7736,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 4,
    'confirmedPaymentCount1': 0,
    'touchCount1': 4,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 4,
    'confirmedPaymentCount2': 0,
    'touchCount2': 4,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 4,
    'confirmedPaymentCount3': 0,
    'touchCount3': 4,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031558055798',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031553042812',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031548032311',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031550007021',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031547025307',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031539056382',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031534040466',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031531026160',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031527027290',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031524014426',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031523020656',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 237,
    'batchNos': '201809031510003798',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'groupName': '仿线上',
    'averagePlayDays': 30,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442.67,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 90,
    'overdueDates': 12,
    'caseAmount': 4328,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031509002914',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 11,
    'averageOverdueDates': 1,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 11,
    'overdueDates': 1,
    'caseAmount': 6000,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 1,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '100.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 1,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 1,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031503046920',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031459059478',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 4,
    'averageOverdueDates': 10,
    'caseTotalCount': 3,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 3,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 12,
    'overdueDates': 30,
    'caseAmount': 18000,
    'msgSendCount': 9,
    'ivrSendCount': 0,
    'caseCount1': 3,
    'confirmedPaymentCount1': 0,
    'touchCount1': 3,
    'contactCount1': 2,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '66.67%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 3,
    'confirmedPaymentCount2': 0,
    'touchCount2': 3,
    'contactCount2': 2,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 3,
    'confirmedPaymentCount3': 0,
    'touchCount3': 3,
    'contactCount3': 2,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 246,
    'batchNos': '201809031459039644',
    'companyName': '财宝宝信息科技有限公司-上海子公司（杨浦职场）',
    'importTime': '2018-09-03',
    'groupName': '途牛科技-策略组',
    'averagePlayDays': 3,
    'averageOverdueDates': 28,
    'caseTotalCount': 1,
    'averageCaseAmount': 541,
    'averageMsgSendCount': 1,
    'averageIvrSendCount': 0,
    'totalCount': 2,
    'playDays': 6,
    'overdueDates': 56,
    'caseAmount': 1082,
    'msgSendCount': 1,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 1,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 1,
    'totalReturnRate1': '100.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '100.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 1,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 1,
    'caseCount3': 1,
    'confirmedPaymentCount3': 1,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 1
  },
  {
    'groupId': 332,
    'batchNos': '201809031458053741',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 15,
    'averageOverdueDates': 1,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 5,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 15,
    'overdueDates': 1,
    'caseAmount': 6000,
    'msgSendCount': 5,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 346,
    'batchNos': '201809031453024910',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '评分策略组',
    'averagePlayDays': 1,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442.75,
    'averageMsgSendCount': 5,
    'averageIvrSendCount': 0,
    'totalCount': 4,
    'playDays': 4,
    'overdueDates': 16,
    'caseAmount': 5771,
    'msgSendCount': 5,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031435055936',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 3,
    'averageOverdueDates': 1,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 2,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 3,
    'overdueDates': 1,
    'caseAmount': 6000,
    'msgSendCount': 2,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 1,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '100.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 1,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 1,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031346023839',
    'companyName': '普柏特分秒贷',
    'importTime': '2018-09-03',
    'averagePlayDays': 1,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 11,
    'batchNos': '201809031124045434',
    'companyName': 'chenli建测试公司',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 1,
    'averageOverdueDates': 1,
    'caseTotalCount': 1,
    'averageCaseAmount': 20,
    'averageMsgSendCount': 6,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 1,
    'caseAmount': 20,
    'msgSendCount': 6,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031122037758',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 21,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 6,
    'averageIvrSendCount': 0,
    'totalCount': 3,
    'playDays': 63,
    'overdueDates': 285,
    'caseAmount': 18000,
    'msgSendCount': 6,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031115045304',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031115011357',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031113037268',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031112053201',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031111017584',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031110055725',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'averagePlayDays': 5,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 5,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031110040240',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 7,
    'averageOverdueDates': 5,
    'caseTotalCount': 1,
    'averageCaseAmount': 150,
    'averageMsgSendCount': 8,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 7,
    'overdueDates': 5,
    'caseAmount': 150,
    'msgSendCount': 8,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031110011352',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031109024250',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'averagePlayDays': 3,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 3,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 332,
    'batchNos': '201809031109000527',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'groupName': '主策略组',
    'averagePlayDays': 2,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 8,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 2,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 8,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031107056630',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'groupId': 252,
    'batchNos': '201809031106044339',
    'companyName': '日蚀',
    'importTime': '2018-09-03',
    'groupName': '主策略',
    'averagePlayDays': 1,
    'averageOverdueDates': 95,
    'caseTotalCount': 1,
    'averageCaseAmount': 6000,
    'averageMsgSendCount': 5,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 95,
    'caseAmount': 6000,
    'msgSendCount': 5,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  },
  {
    'batchNos': '201809031058003164',
    'companyName': '普柏特-1',
    'importTime': '2018-09-03',
    'averagePlayDays': 1,
    'averageOverdueDates': 4,
    'caseTotalCount': 1,
    'averageCaseAmount': 1442,
    'averageMsgSendCount': 0,
    'averageIvrSendCount': 0,
    'totalCount': 1,
    'playDays': 1,
    'overdueDates': 4,
    'caseAmount': 1442,
    'msgSendCount': 0,
    'ivrSendCount': 0,
    'caseCount1': 1,
    'confirmedPaymentCount1': 0,
    'touchCount1': 1,
    'contactCount1': 0,
    'contactReturnCount1': 0,
    'noContactReturnCount1': 0,
    'totalReturnRate1': '0.00%',
    'touchtRate1': '100.00%',
    'contactRate1': '0.00%',
    'contactReturnRate1': '0.00%',
    'noContactReturnRate1': '0.00%',
    'caseCount2': 1,
    'confirmedPaymentCount2': 0,
    'touchCount2': 1,
    'contactCount2': 0,
    'contactReturnCount2': 0,
    'noContactReturnCount2': 0,
    'caseCount3': 1,
    'confirmedPaymentCount3': 0,
    'touchCount3': 1,
    'contactCount3': 0,
    'contactReturnCount3': 0,
    'noContactReturnCount3': 0
  }
];
export { data5, data3 };



// WEBPACK FOOTER //
// ./src/page/main/collection/report/reportData.js